import { useEffect } from "react";

import { PollType } from "./type";

type PollerLike = {
  pause: () => void;
  resume: (type?: PollType) => void;
};

const usePollerFocus = (poller: PollerLike) => {
  useEffect(() => {
    const handleVisibilityChange = () => {
      document.hidden ? poller.pause() : poller.resume();
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () =>
      document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, [poller]);
};

export default usePollerFocus;
